export default __webpack_public_path__ + "media/images/email-icon-1ffb8a362cde28dfd03033dfa09f7d73.svg";